<header class="page-header">
    <h1>{{'page.dashboard.name' | translate | upperFirstLetter}}</h1>
</header>

<div class="content">
    <app-dashboard-client-stats />
    <app-weekly-trends class="u-fade-slide-in" />
    <app-faq class="u-fade-slide-in" />
    <app-last-content class="u-fade-slide-in" />
</div>